<script setup>
import Card from 'primevue/card';
import { useRouter } from 'vue-router';

const props = defineProps({
  employee: {
    type: Object,
    required: true,
    default: () => ({
      works_count: 0,
      works_archived_count: 0,
      objects_count: 0,
      customers_count: 0
    })
  }
});

const router = useRouter();

function goToWorks() {
  if (!props.employee?.id) return;
  router.push({ name: 'works', query: { responsible: props.employee.id } });
}

function goToFacilities() {
  if (!props.employee?.id) return;
  router.push({ name: 'facilities', query: { responsible: props.employee.id } });
}

function goToCustomers() {
  if (!props.employee?.id) return;
  router.push({ name: 'customers', query: { responsible: props.employee.id } });
}

</script>

<template>
  <Card class="w-full p-0">
    <template #content>
      <div class="py-3">
        <div class="flex justify-between">
          <div
              class="flex-1 flex flex-col items-center card-stat-wrapper cursor-pointer"
              role="button"
              tabindex="0"
              @click="goToWorks"
              @keydown.enter.prevent="goToWorks"
              @keydown.space.prevent="goToWorks"
          >
            <div class="card-stat-value">{{ employee.work_count }}</div>
            <div class="gray">работ</div>
          </div>
<!--          <div class="flex-1 flex flex-col items-center card-stat-wrapper">-->
<!--            <div class="card-stat-value">{{ employee.works_archived_count }}</div>-->
<!--            <div class="gray">выполнено</div>-->
<!--          </div>-->
          <div
              class="flex-1 flex flex-col items-center card-stat-wrapper cursor-pointer"
              role="button"
              tabindex="0"
              @click="goToFacilities"
              @keydown.enter.prevent="goToFacilities"
              @keydown.space.prevent="goToFacilities"
          >
            <div class="card-stat-value">{{ employee.facility_count }}</div>
            <div class="gray">объектов</div>
          </div>
          <div
              class="flex-1 flex flex-col items-center card-stat-wrapper cursor-pointer"
              role="button"
              tabindex="0"
              @click="goToCustomers"
              @keydown.enter.prevent="goToCustomers"
              @keydown.space.prevent="goToCustomers"
          >
            <div class="card-stat-value">{{ employee.customer_count }}</div>
            <div class="gray">клиентов</div>
          </div>
        </div>
      </div>
    </template>
  </Card>

</template>

<style scoped />
